<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 3c0-.56.45-1 1-1h7c.56 0 1 .44 1 1v10h-3v-2h-3v2h-3V3Zm2 1v2h2V4h-2Zm2 3h-2v2h2V7Zm3 0h-2v2h2V7Zm0-3h-2v2h2V4ZM2 7l4.5-3L11 7v6H7.5v-2h-2v2H2V7Zm4 0H4v2h2V7Zm1 0v2h2V7H7ZM1 22v-7h22v7H1Zm20-4h-3v1h3v-1Zm-8 0v1h3v-1h-3Zm-2 0H8v1h3v-1Zm-8 0v1h3v-1H3Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M11 2c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v11c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V7c0-.31.15002-.61005.40002-.80005l4-3c.36-.26.83996-.26 1.19996 0L11 5V2Zm0 5.5L8 5.25 5 7.5V12h1.5v-2h3v2H11V7.5ZM7 7h2c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1Zm11 5h1V3h-6v9h1v-2h4v2Zm-4-7c0-.55.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1Zm1 2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1ZM4 18h1c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1Zm-2 3h20c.55 0 1 .45 1 1s-.45 1-1 1H2c-.55 0-1-.45-1-1s.45-1 1-1Zm6-2c0-.55.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1Zm6-1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-.55 0-1-.45-1-1s.45-1 1-1Zm4 1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-.55 0-1-.45-1-1ZM2 15h20c.55 0 1 .45 1 1s-.45 1-1 1H2c-.55 0-1-.45-1-1s.45-1 1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
